var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWavesGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1800,
    height: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f7fffc",
    d: "M0 0h1800v1000H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 200h0c100.305 17.656 200.61 35.313 312 51 111.39 15.687 233.864 29.405 329 0s162.933-101.933 249-111c86.067-9.067 190.403 45.328 294 52 103.597 6.672 206.456-34.38 309-41 102.544-6.62 204.772 21.19 347 49",
    fill: "none",
    stroke: "#d6eae2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 400h0c95.749 14.415 191.497 28.83 292 28 100.503-.83 205.759-16.908 320-37 114.241-20.092 237.467-44.2 326-45 88.533-.8 142.374 21.708 226 41s197.036 35.37 308 37c110.964 1.63 219.482-11.185 368-24",
    fill: "none",
    stroke: "#b4d8ca",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 600h0c81.81-15.52 163.62-31.041 276-17s255.328 57.644 357 53c101.672-4.644 162.067-57.533 258-81 95.933-23.467 227.405-17.51 322-2 94.595 15.51 152.313 40.574 244 50 91.687 9.426 217.344 3.213 383-3",
    fill: "none",
    stroke: "#deeee7",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 800h0c86.185 30.054 172.37 60.108 266 44 93.63-16.108 194.708-78.377 312-97 117.292-18.623 250.8 6.4 362 14 111.2 7.6 200.092-2.223 299-6 98.908-3.777 207.83-1.508 303 7 95.17 8.508 176.585 23.254 298 38",
    fill: "none",
    stroke: "#e2f0ea",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavesGreen);
export default __webpack_public_path__ + "static/media/waves-green.a8a874e35d9cb49275a6ad6ef5378c08.svg";
export { ForwardRef as ReactComponent };